// [A2] 年級標籤渲染 —— 依機構 grade_labels 對照顯示自訂名稱（例如幼稚園「小班」），
// 沒有設定 grade_labels（null，天籟現況）時完全不影響既有各顯示點的 fallback 文字。
//
// 刻意不把 fallback 文字（如「N 年級」/「N年級」，各顯示點原本的間距不完全一致）也收進
// 這支工具：只回傳「有無 override」，讓每個呼叫端保留自己原本的 fallback 寫法，
// 確保天籟（grade_labels=null）逐字零改變。

/**
 * 回傳指定年級的機構自訂標籤；沒有設定則回傳 null（呼叫端應自行 fallback 到原本文字）。
 */
export function getGradeLabelOverride(grade, gradeLabels) {
    if (grade === null || grade === undefined || grade === '') return null;
    if (gradeLabels && Object.prototype.hasOwnProperty.call(gradeLabels, String(grade))) {
        return gradeLabels[String(grade)];
    }
    return null;
}

/**
 * 年級下拉選單的可選清單：機構有設定 grade_labels 時，只列出有標籤的年級（依數字排序，
 * 例如幼稚園只有 1-4）；沒有設定時 fallback 回現行 1-9。
 */
export function getGradeOptions(gradeLabels) {
    if (gradeLabels && Object.keys(gradeLabels).length > 0) {
        return Object.keys(gradeLabels)
            .map((k) => parseInt(k, 10))
            .filter((n) => !Number.isNaN(n))
            .sort((a, b) => a - b);
    }
    return [1, 2, 3, 4, 5, 6, 7, 8, 9];
}
